import { render, staticRenderFns } from "./Setname.vue?vue&type=template&id=11b002e4&scoped=true"
import script from "./Setname.vue?vue&type=script&lang=js"
export * from "./Setname.vue?vue&type=script&lang=js"
import style0 from "./Setname.styles.less?vue&type=style&index=0&id=11b002e4&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b002e4",
  null
  
)

export default component.exports